import type { WorkbookDefinition } from '@erp/shared-types';

/**
 * A Workbook's Definition as a JSON file to send us when it misbehaves: the
 * Definition the editor holds (unsaved edits included), with the Workbook's
 * id and the Revision it was loaded or last saved at.
 */
export function workbookDefinitionExport({
  workbookId,
  revision,
  definition,
}: {
  workbookId: string;
  revision: number;
  definition: WorkbookDefinition;
}): { fileName: string; json: string } {
  const slug =
    definition.name
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 60) || 'workbook';
  return {
    fileName: `${slug}.workbook.json`,
    json: JSON.stringify({ workbookId, revision, definition }, null, 2),
  };
}
